import { PremiumBenefits } from "components/incentive/components/PremiumBenefits"
import { Logo } from "components/incentive/components/Logo"
import { OfferNote } from "./OfferNote"

import css from "../style.module.scss"

export const Sidebar = function Sidebar() {
  return (
    <div className={css.sidebar}>
      <Logo />
      <OfferNote />
      <PremiumBenefits modal />
    </div>
  )
}
